// Copyright (c) 2019 Comsearch, Inc., All rights reserved

export const LOADING_HIDE = 'LOADING_HIDE'
export const LOADING_SHOW = 'LOADING_SHOW'
